import { Config } from './Config';

export class CsvExporter {
  private readonly UTF8_BYTE_ORDER_MARK = new Uint8Array([0xef, 0xbb, 0xbf]);
  private readonly _config: Config;

  public constructor(config: Config) {
    this._config = config;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getExportData(rows: Array<any>, delimiter = ';'): string {
    const columns = (this._config.columns || []).filter((col) => col.hidden === false);
    const headAsCsvString = columns.map((col) => `"${col.title || ''}"`).join(delimiter);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowsAsCsvStrings = rows.map((row: any) =>
      columns
        .map((col) => `"${col.csvExportConverter(row[col.fieldName], row) || ''}"`)
        .join(delimiter)
    );

    return [headAsCsvString].concat(rowsAsCsvStrings).join('\n');
  }

  public downloadExportData(csvExport: string): void {
    const blob = new Blob([this.UTF8_BYTE_ORDER_MARK, csvExport], {
      type: 'text/csv;charset=utf-8'
    });
    const filename = `SmartTable-Export-${new Date().toLocaleString()}.csv`;

    // @ts-ignore
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // @ts-ignore
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const downloadLink = document.createElement('a');

      downloadLink.setAttribute('href', URL.createObjectURL(blob));
      downloadLink.setAttribute('download', filename);
      downloadLink.setAttribute('style', 'display: none;');
      downloadLink.setAttribute('target', '_blank');

      document.body.appendChild(downloadLink);
      downloadLink.click();

      setTimeout(function () {
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(downloadLink.href);
      }, 100);
    }
  }
}
